module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/how_to_enjoy_photography_case1-3ccbe256e54b25a7702e84f3e8decde3.jpg";